import { defineMessages } from 'react-intl';

// The Household History of the resident profile (household-mi-mo-date-changes).
const messages = defineMessages({
  viewUnitHistory: {
    id: 'App.ResidentProfile.UnitHistory.ViewUnitHistory',
    defaultMessage: 'View Household History ({count})',
  },
  title: {
    id: 'App.ResidentProfile.UnitHistory.Title',
    defaultMessage: 'Household History',
  },
  subtitle: {
    id: 'App.ResidentProfile.UnitHistory.Subtitle',
    defaultMessage: 'Every unit this household lived in at this property',
  },
  unit: {
    id: 'App.ResidentProfile.UnitHistory.Unit',
    defaultMessage: 'Unit',
  },
  moveIn: {
    id: 'App.ResidentProfile.UnitHistory.MoveIn',
    defaultMessage: 'Move-In',
  },
  moveOut: {
    id: 'App.ResidentProfile.UnitHistory.MoveOut',
    defaultMessage: 'Move-Out',
  },
  started: {
    id: 'App.ResidentProfile.UnitHistory.Started',
    defaultMessage: 'Started',
  },
  ended: {
    id: 'App.ResidentProfile.UnitHistory.Ended',
    defaultMessage: 'Ended',
  },
  current: {
    id: 'App.ResidentProfile.UnitHistory.Current',
    defaultMessage: 'Current',
  },
  firstMoveIn: {
    id: 'App.ResidentProfile.UnitHistory.FirstMoveIn',
    defaultMessage: 'First move-in',
  },
  movedIn: {
    id: 'App.ResidentProfile.UnitHistory.MovedIn',
    defaultMessage: 'Move-in',
  },
  transferFrom: {
    id: 'App.ResidentProfile.UnitHistory.TransferFrom',
    defaultMessage: 'Transfer from {unitLabel}',
  },
  transferTo: {
    id: 'App.ResidentProfile.UnitHistory.TransferTo',
    defaultMessage: 'Transfer to {unitLabel}',
  },
  transfer: {
    id: 'App.ResidentProfile.UnitHistory.Transfer',
    defaultMessage: 'Transfer',
  },
  movedOut: {
    id: 'App.ResidentProfile.UnitHistory.MovedOut',
    defaultMessage: 'Moved out',
  },
  editMoveIn: {
    id: 'App.ResidentProfile.UnitHistory.EditMoveIn',
    defaultMessage: 'Edit the Move-In Date of Unit {unitLabel}',
  },
  loadError: {
    id: 'App.ResidentProfile.UnitHistory.LoadError',
    defaultMessage: 'The unit history could not be loaded.',
  },
  tryAgain: {
    id: 'App.ResidentProfile.UnitHistory.TryAgain',
    defaultMessage: 'Try again',
  },
  close: {
    id: 'App.ResidentProfile.UnitHistory.Close',
    defaultMessage: 'Close',
  },
});

export default messages;
